import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import ConditonalWrapper from '../../../../common/src/components/ConditionalWrapper';
import useIsAboveViewportHeight from '../../../../common/src/hooks/useIsAboveViewportHeight';
import useMobileBreakpoints from '../../../../common/src/hooks/useMobileBreakpoints';
import { mq } from '../../../../common/src/utils/styledComponentsUtils';
import BottomDrawer from '../default/BottomDrawer';
import ViewHeader from '../legacy/question-view-header/QuestionViewHeader';

interface Props {
  onBack: () => void;
  isHomeQuestion?: boolean;
  dataTestId?: string;
  initialDrawerState?: boolean;
  mobileView?: (
    arg0: (arg0: boolean) => void,
  ) => React.ReactElement | HTMLElement;
}

const ContentLayout: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  onBack,
  isHomeQuestion,
  dataTestId,
  initialDrawerState = false,
  mobileView,
  ...rest
}) => {
  const [showDrawer, setShowDrawer] = useState<boolean>(initialDrawerState);

  const { isLaptop } = useMobileBreakpoints();
  const isMobile = !isLaptop;
  const above480px = useIsAboveViewportHeight('vga');

  return (
    <Container
      data-test-id={dataTestId}
      isHomeQuestion={isHomeQuestion}
      above480px={above480px}
      {...rest}
    >
      <>
        {isMobile && <ViewHeader />}
        {isMobile && mobileView && mobileView(setShowDrawer)}
        <ConditonalWrapper
          condition={isMobile && !!mobileView}
          wrapper={(_children) => (
            <BottomDrawer
              isVisible={showDrawer}
              onClose={() => setShowDrawer(false)}
            >
              <div>{_children}</div>
            </BottomDrawer>
          )}
        >
          <>{children}</>
        </ConditonalWrapper>
      </>
    </Container>
  );
};

const Container = styled.div<{
  isHomeQuestion?: boolean;
  above480px?: boolean;
}>`
  display: grid;
  height: 100%;
  width: 100%;
  grid-template-rows: ${({ above480px }) =>
    above480px ? 'auto minmax(1px, 1fr) auto' : 'auto auto auto'};

  ${mq.laptop} {
    grid-template-rows: minmax(1px, 1fr) auto;
    overflow: auto;
  }

  ${({ isHomeQuestion }) =>
    isHomeQuestion &&
    css`
      ${mq.laptopL} {
        min-width: 66rem;
        max-width: 70rem;
        background-color: white;
        margin-top: 5.6rem;
        margin-left: 5.6rem;
        height: calc(100% - 11.2rem);
        box-shadow: 0 16px 24px rgba(0, 0, 0, 0.06),
          0 2px 6px rgba(0, 0, 0, 0.04), 0 0 1px rgba(0, 0, 0, 0.04);
        border-radius: 5px;
        align-self: flex-start;
        position: relative;
        z-index: 10;
      }

      ${mq.desktopS} {
        max-width: 75rem;
      }

      ${mq.desktop} {
        max-width: 80rem;
      }
    `}
`;

export default ContentLayout;
